import React from "react";
import { useNavigate } from "react-router-dom";
import { extractDate } from "../../../Kryzen Alpha App/Components/Functions/date.fun";
import CustomViewButton from "../../CustomComponent/custom_view_button";
import { FaCheckCircle } from "react-icons/fa";
import { FaCircleXmark } from "react-icons/fa6";
import Stars from "react-stars";
const tableHead = [
  "Sr.",
  "Feedback Date",
  "Feedback Type",
  "Read Status",
  "Actions",
];

const Viewfeedbacktable = ({ data = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/employee-feedbacks/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>{extractDate(item?.createdAt) || "N/A"}</td>
                <td>{item?.feedbackType || "N/A"}</td>
                <td>
                  {item?.markAsRead ? (
                    <Stars count={5} size={15} />
                  ) : (
                    <FaCircleXmark fontSize={"20px"} color="#D80001" />
                  )}
                </td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item?.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Viewfeedbacktable;
